import React, { FC } from 'react';
import useLocale from '@/hooks/useLocale';
import { TypeLink_externalFields } from '@/core/generated-types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { ConditionalBannerProps } from '@/components/common/ConditionalBanner/ConditionalBanner';
import { BannerPresentation } from '@/components/common/ConditionalBanner/components/index';
import { useFlags } from 'launchdarkly-react-client-sdk';

const BfcmCpUpsellBanner: FC<ConditionalBannerProps> = (fields) => {
  const locale = useLocale();
  const { 'enable-bfcm': enableBfcm } = useFlags();
  if (!enableBfcm || !fields.userUuid) return null;

  const playKitsPageLink = constructLegacyCustomerPortalLink(locale, [
    fields.userUuid,
    'subscriptions',
  ]);

  // overrides the link url with the dynamically generated link to the
  // customer's play kit page in the legacy customer portal
  const customizedCtaFields = {
    ...fields.cta.fields,
  } as TypeLink_externalFields;
  customizedCtaFields.linkUrl = playKitsPageLink;
  fields.cta.fields = customizedCtaFields;

  return <BannerPresentation {...fields} testId="bfcm-cp-upsell-banner" />;
};

export default React.memo(BfcmCpUpsellBanner);
